import { Card, Col, Row } from 'react-bootstrap';

import { DidGroupsCreateForm } from '@components/Capacity/DidGroups/Create';

export const Create = () => (
  <Row>
    <Col md={6}>
      <Card>
        <Card.Header className="bg-didxl text-white">
          Add new DID-Group
        </Card.Header>
        <Card.Body>
          <DidGroupsCreateForm />
          <Row className="mt-2">
            <Col>Please note that DID-Group names have to be unique.</Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
);
